import React, { useContext } from "react";
import { OptionImage } from "./style";
import Select from "react-select";
import { updateIndividualShutterColor } from "./service";
import { markBomSummaryStale } from "../project/service";
import { AppContext } from "../context";

const ShutterCustomizationContainer = (props) => {
  const { bomSummary, setBomSummary } = useContext(AppContext);
  const handleShutterColorChange = (shutterLabel, shutterColor) => {
    const requestJson = {
      projectId: props.projectId,
      groupId: props.groupId,
      orderItemId: props.orderItemId,
      shutterLabel: shutterLabel,
      shutterColor: shutterColor,
    };

    updateIndividualShutterColor(requestJson)
      .then(({ response }) => {
        props.setNotificationMessage({
          text: "Shutter Color updated Successfully!",
          type: "success",
        });
        markBomSummaryStale(bomSummary, setBomSummary);
      })
      .catch(({ error }) => {
        props.setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        props.loadOrderItem({ loader: true });
      });
  };

  const renderShutterColorOptions = (shutterLabel, options, shutterConfig) => {
    let optionChildren = null;
    return (
      <>
        <Select
          value={
            options.find(
              (option) => shutterConfig.color === option.identifier
            ) || null
          }
          className="mt-2"
          options={options.map((option, index) => {
            option.value = option.name;
            option.label = option.image ? (
              <div key={index}>
                {option.image && (
                  <OptionImage
                    key={index}
                    src={option.image}
                    alt={option.name}
                    className="me-2 border border-dark rounded-circle"
                  />
                )}
                {option.name}
              </div>
            ) : (
              option.name
            );
            if (option.selected) {
              optionChildren = option.children;
            }

            return {
              ...option,
            };
          })}
          onChange={(selectedOption) => {
            handleShutterColorChange(shutterLabel, selectedOption.identifier);
          }}
        />
      </>
    );
  };

  return (
    <div
      className="box-container border-primary pt-2 pb-2"
      style={{ backgroundColor: "#D9D9D9", marginTop: "20px" }}
    >
      {Object.entries(props.shutterConfigs).map(
        ([shutterLabel, shutterConfig], index) => {
          return (
            <div key={index} className={"d-flex align-items-center"}>
              <div
                className="m-0 d-inline text-capitalize"
                style={{ paddingRight: "10px", paddingLeft: "10px" }}
              >
                {shutterLabel}
              </div>
              <div
                className={"w-100"}
                style={{ paddingRight: "10px", paddingLeft: "10px" }}
              >
                {renderShutterColorOptions(
                  shutterLabel,
                  props.shutterColorOptions,
                  shutterConfig
                )}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

export default ShutterCustomizationContainer;
